// QR Code Generator Agent
import { supabase } from '@/integrations/supabase/client';

export const generateQRCodeURL = async (text: string, size: number = 200): Promise<string> => {
  const { data, error } = await supabase.functions.invoke('runAgent', {
    body: { agent: 'qr-code', text, size }
  });
  if (error) throw new Error(error.message);
  return data.qrUrl;
};

// Export a structured response for the component-based rendering
export const formatQRCodeData = (text: string, qrUrl: string): { __qr_code_generator: boolean; text: string; qrUrl: string } => {
  return {
    __qr_code_generator: true,
    text,
    qrUrl
  };
};
